// LiqScorePill — tiny score badge for the LiqMap topbar.
// Polls `/api/liqmap/liqscore/BTC` every 60s and renders a colored pill.
import React, { useEffect, useState } from "react";
import { API } from "../../lib/api";

const scoreColor = (s) => {
  if (s >= 90) return "#ffffff";
  if (s >= 75) return "#ff3b5c";
  if (s >= 50) return "#ff5a00";
  if (s >= 25) return "#f0c800";
  return "#00d084";
};

export default function LiqScorePill({ coin = "BTC" }) {
  const [score, setScore] = useState(null);
  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const r = await fetch(`${API}/liqmap/liqscore/${coin}`);
        const d = await r.json();
        if (alive && typeof d.score === "number") setScore(d.score);
      } catch { /* silent */ }
    };
    load();
    const id = setInterval(load, 60_000);
    return () => { alive = false; clearInterval(id); };
  }, [coin]);

  if (score == null) return null;
  const c = scoreColor(score);
  return (
    <span
      data-testid="liqscore-pill"
      title={`RE₿EL LiqScore™ ${coin}: ${score}/100`}
      className="inline-flex items-center gap-1 rounded-full border px-2 py-[2px] font-mono text-[10px] font-bold"
      style={{
        borderColor: `${c}66`,
        background: `${c}14`,
        color: c,
      }}
    >
      ⚡ {score}
    </span>
  );
}
